var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contrend-dashboard__header-title"},[_vm._v(" "+_vm._s(_vm.subjects && _vm.subjects[0].name)+" "),_c('hr')]),_c('cs-page-tabs',{staticClass:"ct-main-content",attrs:{"tabs":_vm.tabs},on:{"input":_vm.activeTab}}),_c('breakdown-charts',{attrs:{"breakdown-key":_vm.tabs[_vm.indexTab].key}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }